
const home = {
  hero: {
    title: 'Deriway provides one-stop payment aggregation and acquiring services for overseas enterprises',
    subtitle: 'Covering Southeast Asia, Central Asia, Turkey, Russia, Middle East, Africa, Latin America and multiple payment methods',
    description: 'Professional cross-border payment solutions to help enterprises develop globally, providing secure, efficient and compliant financial service experience.',
    cta: 'Get Started',
    learnMore: 'Learn More'
  },
  stats: {
    countries: 'Countries Covered',
    transactions: 'Daily Transactions',
    uptime: 'System Uptime',
    support: 'Customer Support'
  },
  features: {
    title: 'Why Choose Deriway',
    subtitle: 'Professional fintech solutions to safeguard your business',
    items: [
      {
        title: 'Global Coverage',
        description: 'Support 200+ countries and regions worldwide, covering mainstream payment methods'
      },
      {
        title: 'Security & Compliance',
        description: 'PCI DSS certified, compliant with regulatory requirements of various countries, ensuring fund security'
      },
      {
        title: 'Quick Integration',
        description: 'Simple API integration, 7x24 technical support, quick go-live'
      },
      {
        title: 'Smart Risk Control',
        description: 'AI-driven risk management system, real-time monitoring of transaction security'
      }
    ]
  },
  solutions: {
    title: 'Solutions',
    subtitle: 'Professional solutions for different industries and scenarios',
    items: [
      {
        title: 'E-commerce Payment',
        description: 'Complete payment solutions for cross-border e-commerce'
      },
      {
        title: 'Gaming Top-up',
        description: 'Exclusive top-up and settlement services for gaming industry'
      },
      {
        title: 'Digital Content',
        description: 'Subscription payment solutions for digital products and content'
      }
    ]
  },
  cta: {
    title: 'Ready to Get Started?',
    subtitle: 'Contact us now to get your exclusive payment solution',
    button: 'Contact Us'
  }
};

export default home;
